import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const trads: any = import.meta.glob('../assets/locales/*.json', { eager: true });
const resources: Record<string, any> = {};

const tradMap:any = {};
for (const path in trads) {
  const fileName = path.split('/').pop(); // ex: 'fr.png'
  if(fileName){
      const code:any = fileName.split('.')[0];   // ex: 'fr'
      
      if(code){
        tradMap[code] = trads[path].default;
            resources[code] = { translation: trads[path].default };
      }
  }
}


i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "fr", // langue par défaut (à connecter avec Polylang si besoin)
    fallbackLng: "en",
    interpolation: { escapeValue: false }
  });

export default i18n;
